<template>
  <div class="container">
    <div class="bg-ff flex f-jcenter bg-fff pa-t-20 pa-b-30">
      <div class="flex f-between width60">
        <div class="t-center stop">
          <i class="iconfont icon-dingdandingdanmingxishouzhimingxi"></i>
          <div class="ma-t-10">第一步 提交订单</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop c-red">
          <i class="iconfont icon-zhangdan"></i>
          <div class="ma-t-10 c-666">第二步 确认支付</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop">
          <i class="iconfont icon-dingdan-yiwancheng"></i>
          <div class="ma-t-10 c-666">第三步 支付成功</div>
        </div>
      </div>
    </div>

    <div class="pa-30 bg-fff ma-t-20">
      <div class="flex f-between b-b-1-e3 pa-b-20">
        <div class="fon-18 font-bold">{{ projectData.Name }}</div>
        <div class="font-bold">
          <div class="c-red t-center fon-22">￥{{ Amount }}</div>
          <div>实际支付金额</div>
        </div>
      </div>
      <div class="ma-t-10 t-center">
        <div class="flex f-center f-jcenter ma-t-30 ma-b-30">
          <div id="qrcodeDiv"></div>
        </div>
        <div>微信扫码支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderPay, PayResult, getCrowdFundingDetail } from "../../api.js";
import QRCode from "qrcodejs2";
import wx from "weixin-js-sdk";

export default {
  data() {
    return {
      amountData: {},
      projectData: {},
      amountId: "",
      projectId: "",

      Key: "",
      Amount: "",
      Qrcode: "",
      PayId: "",
      interval: "",
      isWeixin: false,
    };
  },
  activated() {
    if (this.$route.query.Key != this.Key) {
      this.amountId = this.$route.query.amountId;
      this.projectId = this.$route.query.projectId;
      this.Key = this.$route.query.Key;
      this.loadData();

      this.orderAdd();
    }
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },
  methods: {
    //获取众筹信息
    loadData() {
      getCrowdFundingDetail({ id: this.projectId }).then((res) => {
        this.projectData = res.data.Data;
        this.amountData = this.projectData.AmountList.find((item) => {
          if (item.Id == this.amountId) {
            return item;
          }
        });
      });
    },
    //下单
    orderAdd() {
      //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
      var ua = navigator.userAgent.toLowerCase();
      this.isWeixin = ua.indexOf("micromessenger") != -1;
      let openid = localStorage.getItem("openid");
      console.log(openid);
      //如果微信浏览器中没有openid就重新登录
      if (this.isWeixin && !openid) {
        this.$router.push("/Login");
        return;
      }

      orderPay({
        Key: this.Key,
        Type: this.isWeixin ? "weixinm" : "weixin",
        OpenId:openid
      }).then((res) => {
        if (this.isWeixin) {
          this.wxPay(res.data.Data.Data);
        } else {
          console.log(res);
          this.Amount = res.data.Data.Amount;
          this.PayId = res.data.Data.PayId;
          this.Qrcode = res.data.Data.Qrcode;

          let qrcodeDiv = document.getElementById("qrcodeDiv");
          qrcodeDiv.innerHTML = "";
          var qrcode = new QRCode(qrcodeDiv, {
            text: "http://jindo.dev.naver.com/collie",
            width: 128,
            height: 128,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          qrcode.makeCode(this.Qrcode);

          this.getPayState();
        }
      });
    },
    //监听支付结果
    getPayState() {
      this.interval = setInterval(() => {
        PayResult({ PayId: this.PayId }).then((result) => {
          if (result.data.Data) {
            this.$router.push({
              path: "/crowdfunding/pay-3",
              query: {
                projectId: this.projectId,
                amountId: this.amountId,
                Amount: this.Amount,
              },
            });
            clearInterval(this.interval);
          }
        });
      }, 1500);
    },
    //微信内支付
    wxPay(weixin) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: weixin.AppId, // 必填，公众号的唯一标识
        timestamp: weixin.TimeStamp, // 必填，生成签名的时间戳
        nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
        signature: weixin.PaySign, // 必填，签名
        jsApiList: ["chooseWXPay"], // 必填，需要使用的 JS 接口列表
      });
      wx.ready(function () {
        //发起微信支付
        wx.chooseWXPay({
          timestamp: weixin.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: weixin.NonceStr, // 支付签名随机串，不长于 32 位
          package: weixin.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: weixin.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: weixin.PaySign, // 支付签名
          success: function () {
            // 支付成功后的回调函数
            this.$router.push({
              path: "/crowdfunding/pay-3",
              query: {
                projectId: this.projectId,
                amountId: this.amountId,
                Amount: this.Amount,
              },
            });
          },
        });
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
.stop {
  .iconfont {
    font-size: 50px;
  }
}
</style>